var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0206 16.82L18.8906 9.50001C18.3206 8.16001 17.4706 7.40001 16.5006 7.35001C15.5406 7.30001 14.6106 7.97001 13.9006 9.25001L12.0006 12.66C11.6006 13.38 11.0306 13.81 10.4106 13.86C9.78063 13.92 9.15063 13.59 8.64063 12.94L8.42063 12.66C7.71063 11.77 6.83063 11.34 5.93063 11.43C5.03063 11.52 4.26063 12.14 3.75063 13.15L2.02063 16.6C1.40063 17.85 1.46063 19.3 2.19063 20.48C2.92063 21.66 4.19063 22.37 5.58063 22.37H18.3406C19.6806 22.37 20.9306 21.7 21.6706 20.58C22.4306 19.46 22.5506 18.05 22.0206 16.82Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.96984 8.38C8.83657 8.38 10.3498 6.86672 10.3498 5C10.3498 3.13327 8.83657 1.62 6.96984 1.62C5.10312 1.62 3.58984 3.13327 3.58984 5C3.58984 6.86672 5.10312 8.38 6.96984 8.38Z",
    fill: "#A9B7BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.654c1665b1b148d7b8766e00bc28576e.svg";
export { ForwardRef as ReactComponent };